import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Typewriter from "typewriter-effect";
import "./Collage.scss";
import Col from "./Json";

const Collage = ({ main }) => {
  return (
    <section className={`collage-section ${main ? "compact" : ""}`}>
      {/* Header Section */}
      {!main ? (
        <div className="collage-header">
          <Typewriter
            options={{
              strings: ["<span>Running Internship From Below Colleges</span>"],
              autoStart: true,
              loop: true,
            }}
          />
        </div>
      ) : (
        <h2 className="collage-title">Students Coming From</h2>
      )}

      {/* Carousel Section */}
      <Carousel
        autoPlay
        infinite
        autoPlaySpeed={2500}
        pauseOnHover={false}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        swipeable
        draggable={false}
        responsive={{
          desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
          tablet: { breakpoint: { max: 1024, min: 464 }, items: 3 },
          mobile: { breakpoint: { max: 464, min: 0 }, items: 2 },
        }}
        slidesToSlide={1}
        className="collage-carousel"
      >
        {Col.map((item) => (
          <div className="collage-card" key={item.userid}>
            <div className="collage-logo">
              <img
                src={item.collage_img}
                alt={item.collage_name}
                className={main ? "small" : ""}
              />
            </div>
            <h3 className={`collage-name ${main ? "muted" : ""}`}>
              {item.collage_name}
            </h3>
          </div>
        ))}
      </Carousel>
    </section>
  );
};

export default Collage;
